import React from "react";
import { Link } from "react-router-dom";

import projectImg from "../../assets/img/project/pro-4.jpg";

const SingleProject = (props) => {
  const {
    itemClass,
    Image,
    Title,
    categoryOne,
    categoryTwo,
    onClickHandler,
    projectId,
    isMobileApp,
  } = props;

  // Get project ID from title if not provided
  const getProjectId = () => {
    if (projectId) return projectId;

    const titleToId = {
      "eRestaurant POS System": "erestaurant",
      "eStock Inventory Management": "estock",
      "Customer Relationship Manager": "crm-system",
      "StockTally Mobile App": "stocktally",
      "Asset Management System": "asset-management",
      "Attendance Management System": "attendance-management",
      "eStock Mobile App": "estock-mobile",
      "Attendance Admin Mobile App": "attendance-admin",
      "Attendance Employee App": "attendance-employee",
      "Quarter Management System": "quarter-management",
    };

    return titleToId[Title] || "erestaurant";
  };

  // Get colorful gradient background for mobile apps
  const getMobileGradient = () => {
    const gradients = {
      "StockTally Mobile App": "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      "eStock Mobile App": "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      "Attendance Admin Mobile App": "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      "Attendance Employee App": "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
    };
    return gradients[Title] || "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
  };

  return (
    <div className={itemClass ? itemClass : "project-2__item"}>
      <div
        className="project-2__thumb"
        style={
          isMobileApp
            ? {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: getMobileGradient(),
                borderRadius: "12px",
                padding: "20px",
                minHeight: "400px",
              }
            : {}
        }
      >
        <img
          src={Image ? Image : projectImg}
          alt=""
          style={
            isMobileApp
              ? {
                  width: "auto",
                  maxWidth: "100%",
                  maxHeight: "320px",
                  borderRadius: "20px",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
                }
              : {}
          }
        />
        <div className="project-2__img-icon">
          <Link to={`/project-details/${getProjectId()}`}>
            <i className="fal fa-arrow-right"></i>
          </Link>
        </div>
        <div className="project-2__img-text">
          <h4>
            <Link to={`/project-details/${getProjectId()}`}>
              {Title ? Title : "Conference On Projects"}
            </Link>
          </h4>
          <i>
            {categoryOne ? categoryOne : "BUSINESS"} /{" "}
            <span>{categoryTwo ? categoryTwo : "BRANDING"}</span>
          </i>
        </div>
      </div>
    </div>
  );
};

export default SingleProject;
